import { FontWeights, ILinkStyles, IProcessedStyleSet, IStyle, ISpinnerStyles, mergeStyleSets } from "office-ui-fabric-react";
import { AppLayoutSettings } from '../../common/styles/common.styles';

export const getRecoveryLinkStyles = (): ILinkStyles => {
  return AppLayoutSettings.AppCommonStyles.getLinkStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.getAppColorContainer().linkColor);
};

export interface RecoveringPageStyles {
  labelContainer: IStyle;
  buttonContainer: IStyle;
  spinnerContainer: IStyle;
  cancelLinkContainer: IStyle;
  gotItButtonContainer: IStyle;
  imageContainer: IStyle;
}

export const getRecoveringPageStyles = (): IProcessedStyleSet<RecoveringPageStyles> => {
  const styles: RecoveringPageStyles = {
    labelContainer: {
      width: '100%'
    },
    buttonContainer: {
      marginTop: '64px',
      display: 'flex',
      justifyContent: 'space-around',
      width: '100%'
    },
    spinnerContainer: {
      marginTop: '64px',
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    cancelLinkContainer: {
      marginTop: '6px',
      width: '100%'
    },
    gotItButtonContainer: {},
    imageContainer: {}
  };

  return mergeStyleSets(styles);
}

export const getRecoveringPageStylesIfRecoveryFlowTranscriptionEnabled = (): IProcessedStyleSet<RecoveringPageStyles> => {
  const styles: RecoveringPageStyles = {
    labelContainer: {
      width: '100%'
    },
    buttonContainer: {
      paddingTop: '10px',
      display: 'flex',
      width: '100%',
      whiteSpace: 'normal',
      flexWrap: 'wrap'
    },
    spinnerContainer: {
      marginTop: '64px',
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    cancelLinkContainer: {
      marginTop: '6px',
      width: '100%'
    },
    gotItButtonContainer: {
      marginLeft: '10px'
    },
    imageContainer: {
      marginTop: '50%',
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    }
  };

  return mergeStyleSets(styles);
}

export const getSpinnerStyles = (): Partial<ISpinnerStyles> => {
  return {
    circle: {
      borderTopColor: AppLayoutSettings.getAppColorContainer().primaryWidgetColor.value
    },
    label: {
      fontSize: AppLayoutSettings.AppFontSize.mediumFontSizePx,
      fontWeight: FontWeights.regular,
      color: AppLayoutSettings.getAppColorContainer().primaryWidgetColor.value
    }
  };
}